module.exports = __webpack_public_path__ + "img/Pablo Mari.0fac7265.png";